// Préparation des images envoyées à Google / Apple Wallet :
// recadrage aux bonnes dimensions dans le navigateur, puis envoi dans Supabase Storage.
import { supabase } from './supabase'

function chargerImage(fichier) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('Image illisible'))
    img.src = URL.createObjectURL(fichier)
  })
}

function versBlob(canvas, type, qualite) {
  return new Promise(resolve => canvas.toBlob(resolve, type, qualite))
}

// Recadre l'image pour remplir exactement largeur × hauteur (comme « object-fit: cover »)
export async function recadrer(fichier, largeur, hauteur, type = 'image/png') {
  const img = await chargerImage(fichier)
  const canvas = document.createElement('canvas')
  canvas.width = largeur
  canvas.height = hauteur
  const ctx = canvas.getContext('2d')
  const echelle = Math.max(largeur / img.width, hauteur / img.height)
  const w = img.width * echelle
  const h = img.height * echelle
  if (type === 'image/jpeg') { ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, largeur, hauteur) }
  ctx.drawImage(img, (largeur - w) / 2, (hauteur - h) / 2, w, h)
  return versBlob(canvas, type, 0.86)
}

// Logo de secours : les initiales du commerce sur sa couleur
export function logoInitiales(nom, couleur) {
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = 660
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = couleur
  ctx.fillRect(0, 0, 660, 660)
  const initiales = nom.trim().split(/\s+/).slice(0, 2).map(m => m[0]?.toUpperCase() || '').join('') || 'J'
  ctx.fillStyle = '#fff'
  ctx.font = `bold ${initiales.length > 1 ? 260 : 320}px -apple-system, BlinkMacSystemFont, sans-serif`
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillText(initiales, 330, 350)
  return versBlob(canvas, 'image/png')
}

// Envoie l'image dans le dossier du commerçant et renvoie son URL publique
export async function envoyerImage(commerceId, nom, blob) {
  const ext = blob.type === 'image/jpeg' ? 'jpg' : 'png'
  const chemin = `${commerceId}/${nom}-${Date.now()}.${ext}`
  const { error } = await supabase.storage.from('commerces').upload(chemin, blob, { contentType: blob.type })
  if (error) throw error
  return supabase.storage.from('commerces').getPublicUrl(chemin).data.publicUrl
}
